'use client';

import { IconStarEmpty } from '@actr/icons/star-empty';
import { IconStarFilled } from '@actr/icons/star-filled';
import React, { memo } from 'react';

import * as Styled from './style.css';

export type StarProps = {
    isFilled: boolean;
    readOnly?: boolean;
    onRate?: () => void;
    onHoverIn?: () => void;
    onHoverOut?: () => void;
}

const Star: React.FC<StarProps> = ({ isFilled, onRate, onHoverIn, onHoverOut, readOnly }) => {
  function handleOnClickRate() {
    if (readOnly) return;

    if (onRate) {
      onRate();
    }
  }

  function handleOnHoverIn() {
    if (readOnly) return;

    if (onHoverIn) {
      onHoverIn();
    }
  }

  function handleOnHoverOut() {
    if (readOnly) return;

    if (onHoverOut) {
      onHoverOut();
    }
  }

  return (
    <div
      className={Styled.IconContainer}
      onClick={handleOnClickRate}
      onMouseEnter={handleOnHoverIn}
      onMouseLeave={handleOnHoverOut}>
      {isFilled
        ? (<IconStarFilled className={Styled.StarRatingFilledIcon} />)
        : (<IconStarEmpty className={Styled.StarRatingEmptyIcon} />)}
    </div>
  );

};

export default memo(Star);
